module.exports = __webpack_public_path__ + "kudos_3.svg?b72ca4a2d22fbba417ab7b59897a05fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_3.svg
// module id = 128
// module chunks = 0